"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnOutsideClick = void 0;
var react_1 = require("react");
function useOnOutsideClick(element, onOutsideClick) {
    react_1.useEffect(function () {
        //@ts-ignore
        if (!element)
            return;
        var onBodyClick = function (event) {
            function clickedElementIsInside(el) {
                if (!el) {
                    return false;
                }
                if (el === element) {
                    return true;
                }
                if (el === document.body) {
                    return false;
                }
                return el.parentElement !== null && clickedElementIsInside(el.parentElement);
            }
            // The cast might not be safe, check here:
            //  https://stackoverflow.com/questions/45454573/angular-property-parentnode-does-not-exist-on-type-eventtarget
            if (element && event.currentTarget !== null && !clickedElementIsInside(event.currentTarget)) {
                onOutsideClick();
            }
        };
        document.body.addEventListener('click', onBodyClick, false);
        return function () { return document.body.removeEventListener('click', onBodyClick); };
    }, [onOutsideClick, element]);
}
exports.useOnOutsideClick = useOnOutsideClick;
//# sourceMappingURL=outside-click.js.map